import Component from "./teamProfile";

import { bindActionCreators } from "redux";
import {
  getTeamProfile,
  updateTeamProfile,
  sendInvitationToTeam,
  deleteMember,
  approveMember,
  deleteMemberFromSlot,
  payForTeamSlot,
  addLicenseForSlot,
  assignPayment,
  leaveTeam,
  getInvoice,
  payForTeamSlots,
} from "../../store/actions/team";
import { updateUserProfile } from '../../store/actions/user';
import { getCarValues } from "../../store/actions/carValues";
import { getRacingBracket } from "../../store/actions/racingBraket";
import connect from "react-redux/es/connect/connect";

function mapStateToProps(state) {
  const team = state.team;
  const carValues = state.carValues;
  const racingBracket = state.racingBracket;

  return {
    team,
    carValues,
    racingBracket,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getTeamProfile,
      getCarValues,
      getRacingBracket,
      updateTeamProfile,
      sendInvitationToTeam,
      deleteMember,
      approveMember,
      deleteMemberFromSlot,
      payForTeamSlot,
      payForTeamSlots,
      addLicenseForSlot,
      assignPayment,
      leaveTeam,
      getInvoice,
      updateUserProfile
      
    },
    dispatch
  );
}

export const TeamProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
